<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { mqLess } from 'src/modules/viewport_module';
import Intersect from 'vue-intersect';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  components: {
    Intersect
  },
  data: function() {
    return {
    };
  },
  methods: {
    mqLess: mqLess,
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL,
    mayToggleVideoPopup() {
      if (this.videoPopupPresent) {
        Vue.set(globalState, "videoPopupContent", { content: this.content, containerContent: this.containerContent });
      }
    },
  },
  computed: {
    videoPopupPresent() {
      return Fandom.exists(this.content.play) || Fandom.exists(this.content.embed_media);
    },
    height() {
      if (this.mqLess("sm")) {
        return {
          class: "mh-100vh-header",
          style: {}
        };
      } else {
        return {
          class: (this.content.height_class || ""),
          style: {
            "min-height": this.content.height
          }
        };
      }
    }
  }
};
</script>

<template>
  <div
    v-easyadmin="easyadminId"
    :class="[contentType, paddingY]" 
    v-if="isContentVisibleToUser()" 
    :style="[theme, {'background-color': content.background_color}]"
    stripe-video-popup-component
  >
    <div :style="{'background-image': getContentResponsiveImageURL('background_image')}" class="bg-cover-center">
      <div class="position-relative" :class="content.propagate_container ? 'container-fluid' : 'container'">
        <div class="row justify-content-center align-items-center">
          <div
            class="text-section-container align-items-center d-flex justify-content-center flex-column content-container"
            :class="[height.class]"
            :style="height.style"
            >
            <div v-if="videoPopupPresent">
              <div class="play-icon-container my-3 cursor-pointer" @click="mayToggleVideoPopup()" >
                <i class="fas fa-play ml-1"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-video-popup-component] {
  background-color: var(--theme-background);
  color: var(--theme-color);
  position: relative;


  @include media-breakpoint-up(xl) {
    .text-section-container {
      min-height: auto !important;
    }
  }

  .play-icon-container {
    position: relative;
    font-size: 1.75rem;

    &:before {
      content: "";
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      border-radius: 100%;
      border: 3px solid $primary;
      animation: playIconAnimation 2s infinite;
    }
  }

  @-webkit-keyframes playIconAnimation {
    0% {
      -webkit-transform: scale(1);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(1.4);
      opacity: 0;
    }
  }

  @keyframes playIconAnimation {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(1.4);
      opacity: 0;
    }
  }
}
</style>
